module.exports = __webpack_public_path__ + "img/CPT00.01fd7516.svg";